<template>
  <div class="page-content animate__animated animate__fadeIn">
    <div class="border-bottom" style="margin-top:0;">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="字典标签">
            <el-input v-model="queryParams.dictLabel" placeholder="请输入字典标签进行查询" class="form-item-width"
              clearable></el-input>
          </el-form-item>

          <div class="btn-boxs">
            <div>
              <el-button icon="el-icon-plus" type="primary" @click="handledictDataAdd">新 增</el-button>
              <el-button :disabled="!multipleSelection.length" icon="el-icon-delete" type="danger"
                @click="batchDelete">批量删除</el-button>
            </div>
            <div>
              <el-button icon="el-icon-search" type="primary" @click="onSearch">查 询</el-button>
              <el-button icon="el-icon-refresh" @click="onReset">重 置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="margin-top" style="margin-bottom:0;margin-top:15px">
      <!-- 表格组件 -->
      <el-table v-loading="tableLoading" :data="tableData" border row-key="deptId" default-expand-all
        :tree-props="{ children: 'children' }" highlight-current-row max-height="447"
        :header-cell-style="{ background: '#fafafa', color: '#606266', fontSize: '14px' }"
        @selection-change="handleSelectionChange">
        <!-- 多选 -->
        <el-table-column type="selection" width="55"></el-table-column>
        <!-- 序号列 -->
        <el-table-column align="center" type="index" label="序号" width="50"></el-table-column>
        <!-- 动态生成其他列 -->
        <el-table-column align="center" v-for="tab in tableTitle" :key="tab.code" :label="tab.name"
          show-overflow-tooltip :width="tab.width">
          <template slot-scope="scope">
            <!-- 针对 status 列的特殊处理 -->
            <span v-if="tab.code === 'status'"
              :style="scope.row.status === '0' ? { color: 'green' } : { color: 'red' }">{{ scope.row.status === '0' ?
          '正常' : '停用' }}</span>
            <span style="color:#337ab7;cursor: pointer;" v-else-if="tab.code === 'dictType'">{{
          scope.row.dictType }}</span>
            <!-- 其他列的常规展示 -->
            <span v-else>{{ scope.row[tab.code] }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="updateData(scope.row)" class="update-btn">修改</el-button>
            <el-button style="color:red" type="text" @click="deleteData(scope.row)" class="update-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination background :total="pageParams.total" :page="pageParams.pageNum" :limit="pageParams.pageSize"
          @pagination="onChangePages" />
      </div>
    </div>
    <!-- 添加 修改角色 -->
    <el-dialog :title="dialogTitle" :visible.sync="deptFormVisible" width="30%" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="字典类型" prop="dictType">
          <el-input disabled v-model="form.dictType" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="字典标签" prop="dictLabel">
          <el-input v-model="form.dictLabel" autocomplete="off" placeholder="请输入字典标签"></el-input>
        </el-form-item>
        <el-form-item label="字典键值" prop="dictValue">
          <el-input v-model="form.dictValue" autocomplete="off" placeholder="请输入字典键值"></el-input>
        </el-form-item>
        <el-form-item label="是否默认" prop="isDefault">
          <el-select v-model="form.isDefault" placeholder="请选择是否默认">
            <el-option label="是" value="Y"></el-option>
            <el-option label="否" value="N"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择状态">
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :icon="dialogTitle === '新增' ? 'el-icon-plus' : 'el-icon-edit'" type="primary"
          @click="submitForm('form')">{{ dialogTitle === '新增' ? '立即添加' : '立即修改' }}</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm('form')">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getDictDataList, dictDataAdd, dictDataById,updeteDictData,deleteDictData} from "@/api/admin-service/dictData.js";
export default {
  name: "dictData",
  components: {
    Pagination
  },
  data() {
    return {
      tableLoading: false,
      form: {
        dictType: "",
        dictLabel: "",
        dictValue: "",
        isDefault: "",
        status: ""
      },
      rules: {
        dictType: [
          { required: true, message: "请填写字典类型", trigger: "blur" }
        ],
        dictLabel: [
          { required: true, message: "请填写字典标签", trigger: "blur" }
        ],
        dictValue: [
          { required: true, message: "请填写字典键值", trigger: "blur" }
        ],
        isDefault: [
          { required: true, message: "请选择是否默认", trigger: "change" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }]
      },
      dialogTitle: "",
      updateId: "", //修改数据需要的id
      deptFormVisible: false,
      // 表格数据
      tableData: [],
      // 表格标题数组
      tableTitle: [
        { name: "字典类型", code: "dictType", width: "" },
        { name: "字典标签", code: "dictLabel", width: "" },
        { name: "字典键值", code: "dictValue", width: "" },
        { name: "是否默认", code: "isDefault", width: "" },
        { name: "状态", code: "status", width: "" }
      ],
      pageParams: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      queryParams: {
        orderByColumn: "",
        isAsc: "",
        dictLabel: "", //字典标签
        dictValue: "", //	字典键值
        dictType: "", //	字典类型
        isDefault: "", // 	是否默认（Y是 N否）
        status: "", // 	状态（0正常 1停用）
        orderBy: ""
      },
      multipleSelection: []
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query.dictType) {
      this.form.dictType = query.dictType;
      this.queryParams.dictType = query.dictType;
    }
    this.onGetDataList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDelete() {
      this.$confirm(`提示，确定要删除选中的这些数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
        // 为按钮添加图标并设置为 mini 尺寸
        confirmButtonClass: "el-icon-check el-button--mini", // 确定按钮的图标和尺寸
        cancelButtonClass: "el-icon-close el-button--mini" // 取消按钮的图标和尺寸
      })
        .then(() => {
          // 使用 map() 来获取 dictCode 组成的数组
          const ids = (this.multipleSelection || []).map(item => item.dictCode);
          deleteDictData({ ids }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 增 / 改
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle === "新增") {
            const formData = { ...this.form };
            delete formData.dictCode; // 清除 userId
            dictDataAdd(formData).then(res => {
              if (res.data) {
                this.$message.success(res.msg || "新增成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          } else {
            updeteDictData({
              ...this.form,
              dictCode: this.updateId
            }).then(r => {
              if (r.data) {
                this.$message.success(r.msg || "修改成功！");
                this.deptFormVisible = false;
                this.onGetDataList();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删
    deleteData(row) {
      this.$confirm(`提示，确定要删除该条数据吗？`, {
        title: "提示",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteDictData({ ids: [row.dictCode] }).then(res => {
            if (res?.data) {
              this.$message.success(res.msg || "删除成功");
              this.onGetDataList();
              this.form.menuIds = [];
            }
          });
        })
        .catch(error => {
          console.log(error);
          // 取消删除时显示提示
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 改
    updateData(row) {
      this.dialogTitle = "修改";
      this.deptFormVisible = true;
      this.updateId = row.dictCode;
      dictDataById({ id: row.dictCode }).then(res => {
        Object.assign(this.form, res?.data);
      });
    },
    // 查
    onGetDataList() {
      this.tableLoading = true;
      getDictDataList({
        ...this.queryParams,
        ...this.pageParams
      })
        .then(res => {
          const { records, total } = res.data;
          this.tableData = records.map(item => {
            return {
              ...item,
              isDefault: item.isDefault === "Y" ? "是" : "否"
            };
          });
          this.pageParams.total = total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    handledictDataAdd() {
      this.dialogTitle = "新增";
      this.deptFormVisible = true;
    },
    handleDialogClose() {
      this.resetForm("form");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 查询
    onSearch() {
      this.onGetDataList();
    },
    // 重置
    onReset() {
      this.pageParams.pageNum = 1
      this.pageParams.pageSize = 10
      this.queryParams.dictLabel = "";
      this.onSearch();
    },
    // 分页方法
    onChangePages(pageInfo) {
      this.pageParams.pageNum = pageInfo.page;
      this.pageParams.pageSize = pageInfo.limit;
      this.onGetDataList();
    }
  }
};
</script>
<style lang="less" scoped>
.analyse-container {
  display: flex;
  height: 95vh;
}

.form-item-width {
  width: 250px;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}
</style>